export {default, type FulfillmentDetailFormProps, type ValidateAddressFunction} from './EventBar';
